import HotelIndex from '@/pages/hotel/'
import BERoom from '@/pages/hotel/be/Room'
import BERoomType from '@/pages/hotel/RoomType'
import BERoomTypeDetail from '@/pages/hotel/RoomTypeDetail'
import BePaymentResult from '@/pages/hotel/be/BePaymentResult'
import BeConfirmPayment from '@/pages/hotel/be/BeConfirmPayment'
import BeDirectFilter from '@/pages/hotel/be/BeDirectFilter'
import BeDirectDetail from '@/pages/hotel/be/BeDirectDetail'
import BeDirectPromo from '@/pages/hotel/be/BeDirectPromo'
import BeDirectPromotion from '@/pages/hotel/be/BeDirectPromotion'
import BeOrderHistory from '@/pages/hotel/be/BeOrderHistory'

const emptyView = {template: '<router-view></router-view>'} 

export default [
  {
    path: 'booking',
    name: 'BERoom',
    component: BERoom,
    meta:{
      module_type: 'merchant-hotel-booking_engine',
      pageType: 'room_search',
      no_wrapper: true,
      title: 'Booking'
    }
  },
  {
    path: 'booking-v3',
    name: 'BERoomV3',
    component: BERoom,
    meta:{
      module_type: 'merchant-hotel-booking_engine',
      pageType: 'room_search',
      no_wrapper: true,
      title: 'Booking'
    }
  },
  {
    path: 'room-type',
    name: 'BERoomTypeBase',
    component: emptyView,
    children: [
      {
        path: '',
        name: 'BERoomType',
        component: BERoomType,
        meta:{
          module_type: 'merchant-hotel-booking_engine',
          no_wrapper: true,
          title: 'Room Type'
        }
      },
      {
        path: ':room_type_id',
        name: 'BERoomTypeDetail',
        component: BERoomTypeDetail,
        meta:{
          module_type: 'merchant-hotel-booking_engine',
          pageType: 'room_detail',
          no_wrapper: true,
          resolveInComponent: true
        }
      },
    ]
  },
  {
    path: 'be',
    component: emptyView,
    children: [
      {
        path: 'payment-result/:tx_order_id',
        name: 'BePaymentResult',
        component: BePaymentResult,
        meta:{
          module_type: 'merchant-hotel-booking_engine',
          pageType: 'payment_result',
          no_wrapper: true,
          title: 'Reservation Result'
        }
      },
      {
        path: 'confirm-payment/:tx_order_id',
        name: 'BeConfirmPayment',
        component: BeConfirmPayment,
        meta:{
          module_type: 'merchant-hotel-booking_engine',
          pageType: 'payment',
          no_wrapper: true,
          title: 'Confirm Payment'
        }
      },
      {
        path: 'promo/:promo_code',
        name: 'BeDirectPromo',
        component: BeDirectPromo,
        meta:{
          module_type: 'merchant-hotel-booking_engine',
          pageType: 'promo'
        }
      },
      {
        path: 'promo_id/:promotion_id',
        name: 'BeDirectPromotion',
        component: BeDirectPromotion,
        meta:{
          module_type: 'merchant-hotel-booking_engine',
          title: 'Applying Filter'
        }
      },
    ]
  },
  {
    path: 'hotel-filter-redirect/:check_in/:check_out/:promo_code',
    name: 'BeDirectFilter',
    component: BeDirectFilter,
    meta:{
      module_type: 'merchant-hotel-booking_engine',
      title: 'Applying Filter'
    }
  },
  {
    path: 'hotel-direct-detail/:type/:sort_by/:id',
    name: 'BeDirectDetail',
    component: BeDirectDetail,
    meta:{
      module_type: 'merchant-hotel-booking_engine',
      title: 'Applying Filter'
    }
  },
  {
    path: 'hotel/order-history',
    name: 'BeOrderHistory',
    component: BeOrderHistory,
    meta:{
      module_type: 'merchant-hotel-booking_engine',
      pageType: 'trx_history'
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/merchant/hotel/BookingEngine.js